import { useState, type FormEvent } from 'react';
import { login } from '../api';

export function Login({ onDone }: { onDone: () => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login({ username, password });
      onDone();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
      setSubmitting(false);
    }
  }

  const ready = username.trim().length > 0 && password.length > 0;

  return (
    <div className="gate">
      <div className="gate-card">
        <div className="gate-brand">
          <span className="brand-mark" />
          <span className="brand-name">Operator</span>
        </div>
        <div className="eyebrow" style={{ marginTop: 20 }}>Sign in</div>
        <h1 className="gate-title">
          Welcome <em>back.</em>
        </h1>

        <form className="gate-form" onSubmit={submit}>
          <div className="field">
            <label className="field-label" htmlFor="u">Username</label>
            <input
              id="u"
              className="input input-mono"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              spellCheck={false}
              autoComplete="username"
            />
          </div>
          <div className="field">
            <label className="field-label" htmlFor="p">Password</label>
            <input
              id="p"
              className="input input-mono"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="form-error">{error}</div>}

          <div className="submit-row">
            <div className="submit-hint">&nbsp;</div>
            <button className="btn-primary" type="submit" disabled={!ready || submitting}>
              {submitting ? <span className="spinner" /> : null}
              {submitting ? 'Signing in' : 'Sign in →'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
